import {Component, OnInit} from '@angular/core';

import {LocationService} from './location.service';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import {AppComponent} from './app.component';
import {Router} from '@angular/router';
import {AuthentificationService} from './authentification.service';
import {WharehousesService} from './warehouses.service';
import {EntrepotService} from './entrepot.service';

import {MdSnackBar} from '@angular/material';

@Component({
    selector: 'app-entrepot',
    templateUrl: './templates/entrepot.component.html',
    styleUrls: ['./styles/entrepot.component.css'],
    providers: [AuthentificationService, EntrepotService, LocationService, WharehousesService]
})
export class EntrepotComponent implements OnInit {

    operation: string = 'CREATION';

    showForm: boolean = true;
    entrepot_form: FormGroup;

    hide_dialog: boolean = false;

    bt_action: any = 'Ajouter';
    key_word: string = '';

    entrepot: any = {
        id_location: '',
        location: '',
        reference: '',
        reference_parent: '',
        reference_old: '',
    };

    entrepots_list: Array<any> = [];

    constructor(
        private app_component: AppComponent,
        private fb: FormBuilder,
        private authentification_service: AuthentificationService,
        private entrepot_service: EntrepotService,
        private location_service: LocationService,
        private warehouses_service: WharehousesService,
        public snackBar: MdSnackBar,
        private router: Router
    ) {
        this.app_component.valTest = '/warehouses';
        this.app_component.GetParent();
    }

    ngOnInit() {
        this.createForm();
        this.checkUSerSession();
        this.GetEntrepots();
    }

    createForm() {
        this.entrepot_form = this.fb.group({
            name_ctrl: ['', Validators.required],
            reference_ctrl: ['', Validators.required]
        });
    }

    GetEntrepots() {
        this.entrepot_service.GetEntrepots()
            .then(result => {
                this.entrepots_list = result['list'];
            });
    }

    InsertEntrepot() {
        this.entrepot_service.InsertEntrepot(this.entrepot.location, this.entrepot.reference)
            .then(result => {
                if (result['result'] != 'OK') {
                    this.SnackBar('Erreur : ', result['result']);
                } else {
                    this.entrepots_list = result['list'];
                    this.SnackBar('Erreur : ', 'Entrepôt créé avec succès.');
                    this.reset();
                }
            });
    }

    UpdateEntrepot() {
        this.entrepot_service.UpdateEntrepot(this.entrepot.id_location, this.entrepot.location, this.entrepot.reference, this.entrepot.reference_old)
            .then(result => {
                if (result['result'] != 'OK') {
                    this.SnackBar('Erreur : ', result['result']);
                } else {
                    this.entrepots_list = result['list'];
                    this.SnackBar('Erreur : ', 'Entrepôt modifié avec succès.');
                    this.reset();
                }
            });
    }

    validateButton() {
        if (this.entrepot_form.status === 'VALID') {
            switch (this.bt_action) {
                case 'Ajouter':
                    this.InsertEntrepot();
                    break;
                case 'Modifier':
                    this.UpdateEntrepot();
                    break;
            };
        }
    }

    deleteEntrepot() {
        this.entrepot_service.DeleteEntrepot(this.entrepot.reference)
            .then(result => {
                this.entrepots_list = result['list'];
            });
        this.hide_dialog = false;
        this.app_component.hide_wrapper(this.hide_dialog);
        this.reset();
    }

    cancelDialog() {
        this.hide_dialog = false;
        this.app_component.hide_wrapper(this.hide_dialog);
    }

    editEntrepot(entrepot: any) {
        this.entrepot.id_location = entrepot.id_location;
        this.entrepot.location = entrepot.location;
        this.entrepot.reference = entrepot.reference;
        this.entrepot.reference_old = entrepot.reference;
        this.entrepot.reference_parent = entrepot.reference_parent;
        this.bt_action = 'Modifier';
        this.operation = 'MODIFICATION';
    }

    removeEntrepot(location: any) {
        this.entrepot.id_location = location.id_location;
        this.entrepot.reference = location.reference;
        this.entrepot.location = location.location;
        this.hide_dialog = true;
        this.app_component.hide_wrapper(this.hide_dialog);
    }

    reset() {
        this.entrepot_form.reset();
        this.showForm = false;
        setTimeout(() => {
            this.bt_action = 'Ajouter';
            this.operation = 'CREATION';
            this.createForm();
            this.showForm = true;
        });
    }

    checkUSerSession(): void {
        this.authentification_service.UserCheckSession()
            .then(result => {
                if (result['id_user'] === 0) {
                    this.router.navigate(['authentification'])
                }
            });
    }

    SnackBar(title: any, message: any) {
        this.snackBar.open(title, message, {
            duration: 2500
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/entrepot.component.ts